import {Dispatch} from "redux"
import {connect} from "react-redux"

// Actions
import * as a from "../store/actions"

// Models
import {User} from "../models"
import {RootState} from "../../../models"

// Selectors
import {selectUser} from "../store/selectors"

/**
 * @param state
 */
const mapStateToProps = (state: RootState) => ({
    user: selectUser(state),
});

/**
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchCurrentUser: () => dispatch(a.fetchCurrentUserAsync.request()),
});

/**
 * @param BaseComponent
 */
export default (BaseComponent: any) =>
    connect(mapStateToProps, mapDispatchToProps)(BaseComponent)

export type WithUserProps = {
    user: User | null
    fetchCurrentUser(): void
}
